import { React, Fragment, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  addSocialMediaRequest,
  resetData,
} from "../../../redux/jobseeker/social_media/actions";
import Select from "react-select";
import { customOptionsStyle, socialMediaOptions } from "../../../Constant";
import { showToast } from "../../Common/Toast";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import validator from "validator"; // Import the validator library

const AddSocialMedia = (props) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    id: "",
    social_profile_name: null,
    url: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: "" }); // Clear error for the field being changed
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const data = {
        id: formData.id,
        social_profile_name:
          formData.social_profile_name.value || formData.social_profile_name,
        url: formData.url,
      };

      // Dispatch your action to update personal info
      dispatch(addSocialMediaRequest(data));
    }
  };

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.social_profile_name) {
      errors.social_profile_name = "Social profile name is required";
      isValid = false;
    }

    const urlRegex = /^[a-zA-Z0-9:/?&=._-]+$/; // Allowed URL characters
    
    if (!formData.url) {
      errors.url = "URL is required";
      isValid = false;
    } else {
      try {
        // Ensure URL starts with http:// or https://
        if (!validator.isURL(formData.url, { require_protocol: true })) {
          throw new Error("Invalid URL format");
        }
    
        // Prevent multiple "https://"
        const httpsCount = (formData.url.match(/https:\/\//g) || []).length;
        if (httpsCount > 1) {
          throw new Error("Malformed URL");
        }
    
        // Check for special characters
        if (!urlRegex.test(formData.url)) {
          throw new Error("URL contains invalid characters");
        }
    
        const urlObject = new URL(formData.url);
        const hostname = urlObject.hostname.replace(/^www\./, ""); // Normalize domain
    
        const domainMap = {
          FACEBOOK: "facebook.com",
          GITHUB: "github.com",
          LINKEDIN: "linkedin.com",
          TWITTER: ["twitter.com", "x.com"],
          STACK_OVERFLOW: "stackoverflow.com",
        };
    
        const profileKey = formData.social_profile_name.value.toUpperCase();
        const profileName = capitalizeFirstLetter(formData.social_profile_name.value);
    
        if (domainMap[profileKey]) {
          const expectedDomains = domainMap[profileKey];
          const isValidDomain = Array.isArray(expectedDomains)
            ? expectedDomains.includes(hostname)
            : hostname === expectedDomains;
    
          if (!isValidDomain) {
            errors.url = `Invalid ${profileName} URL`;
            isValid = false;
          }
        }
      } catch (error) {
        errors.url = error.message;
        isValid = false;
      }
    }

    setErrors(errors);
    return isValid;
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleSocialMediaChange = (selectedOptions) => {
    const updatedErrors = { ...errors, social_profile_name: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, social_profile_name: selectedOptions });
  };

  const socialReducerData = useSelector((state) => state.socialMediaReducer);

  useEffect(() => {
    if (socialReducerData.status && socialReducerData.message !== "") {
      dispatch(fetchJobseekerDataRequest());
      dispatch(resetData());
    } else if (socialReducerData.status === false && socialReducerData.message !== "") {
      dispatch(resetData());
    }
  }, [dispatch, socialReducerData]);

  return (
    <Form className="theme-form">
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>
              Social Profile Name
              <span className="text-danger">*</span>
            </Label>
            <Select
              placeholder="Select profile name"
              isDisabled={false}
              name="social_profile_name"
              styles={customOptionsStyle}
              options={props.options}
              onChange={handleSocialMediaChange}
              value={formData.social_profile_name}
            />
            {errors.social_profile_name && (
              <small className="text-danger">{errors.social_profile_name}</small>
            )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>
              <b>URL</b>
              <span className="font-danger">*</span>
            </Label>
            <Input
              type="text"
              name="url"
              className="form-control form-control-sm"
              placeholder="Enter URL"
              value={formData.url}
              onChange={handleChange}
            />
            {errors.url && <small className="text-danger">{errors.url}</small>}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-end">
          <Button
            disabled={socialReducerData.isLoading}
            color="primary"
            onClick={handleSubmit}
          >
            Add
          </Button>
          <Button color="secondary" onClick={props.onClose}>
            Close
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default AddSocialMedia;